
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();

  // Attendre la fin du chargement avant de rediriger
  if (isLoading) {
    return <div>Chargement...</div>;
  }

  if (!isAuthenticated) {
    console.log("🔄 ProtectedRoute - Redirection vers login");
    return <Navigate to="/" replace />;
  }

  return children;
}
